export default class IdRequest {
  id: string
}
